import {
  IBasePagingRes,
  IBaseResponseModel,
} from "../../models/common/models.type";
import api from "../remote/baseApi";
import ApiEndpoints from "../remote/apiEndpoints";
import { envConfig } from "../../config/env.config";
import { EContentResponse, ESeoResponse } from "../../models/seo";
import { EBlogResponse, IBlogGetPage } from "../../models/blog";
import { ESettingResponse } from "../../models/setting";

const API = ApiEndpoints.Setting;
const baseURL = envConfig.API_ENDPOINT;

const getSingle = async (): Promise<IBaseResponseModel<ESettingResponse>> => {
  return api.get(baseURL, API.GetSingle.url);
  //return res;
};

const createOrUpdate = async (
  data: ESettingResponse,
): Promise<IBaseResponseModel<ESettingResponse>> => {
  return api.post(baseURL, API.CreateOrUpdate.url, data);
  //return res;
};

const SettingService = {
  getSingle,
  createOrUpdate,
};

export default SettingService;
